import { Voucher } from "@/interfaces/domain/Voucher";
import { api } from "@/services/api";

export type ValidateVoucherPayload = {
  code: string;
  storeId: string;
  clientId: string;
  orderAmount: number;
  shipmentValue: number;
};

export type ValidateVoucherResult = Voucher | { error: string };

export async function validateVoucher({
  code,
  clientId,
  storeId,
  orderAmount,
  shipmentValue,
}: ValidateVoucherPayload) {
  const { data } = await api.get<ValidateVoucherResult>(
    `/cupom-promocional/codigo/${code}/cliente/${clientId}/estabelecimento/${storeId}?valor_pedido=${orderAmount}&valor_frete=${shipmentValue}`
  );
  return data;
}
